module.exports = __webpack_public_path__ + "static/media/off.19124b44.png";